import { fileServer, serverUrl } from "../configs/server"

//get all lecture notes
export const getAllNotes = () => {
    return fetch(`${serverUrl}/accounts/alldocuments`, {
        method: "GET",
        headers: {
            "Accept": "application/json"
        },
        mode: "cors"
    });
}

//get notes comments
export const getComments = (id) => {
    return fetch(`${serverUrl}/accounts/commentsbyId/${id}`, {
        method: "GET",
        headers: {
            "Accept": "application/json"
        }
    });
}

export const getAllprojects = () => {
    return fetch(`${serverUrl}/accounts/dissertation`, {
        method: "GET",
        headers: {
            "Accept": "application/json"
        }
    })
}

//get project by id //
export const getPojectById = (id) => {

}

//get all ebooks
export const getAllEbboks = () => {
    return fetch(`${serverUrl}/accounts/ebooks`, {
        method: "GET",
        headers: {
            "Accept": "application/json"
        }
    })
}

//get all videos
export const getAllVideos = (signal) => {
    return fetch(`${serverUrl}/accounts/allvideos`, {
        method: "GET",
        headers: {
            "Accept": "application/json"
        },
        signal
    })
}

export const getNoteById = (id) => {
    return fetch(`${serverUrl}/accounts/lecture/${id}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
}

//comment on a document
export const commentDoc = (id, token, comment) => {
    return fetch(`${serverUrl}/accounts/addComment/${id}`, {
        method: "POST",
        body: JSON.stringify({ comment }),
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    });
};

//like document
export const likeDoc = (id, token) => {
    return fetch(`${serverUrl}/accounts/like/${id}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        }
    });
}

//get comments
export const getPostComments = (id) => {
    return fetch(`${serverUrl}/accounts/commentsbyId/${id}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
        }
    });
}

//edit a comment
export const editComment = (id, text, token) => {
    return fetch(`${serverUrl}/accounts/editcomment/${id}`, {
        method: "PATCH",
        body: JSON.stringify({ comment: text }),
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    });
}

//delete comment
export const deleteComment = (id, token) => {
    return fetch(`${serverUrl}/accounts/deletecomment/${id}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        }
    });
}

//get all accounts
export const getAllUsers = (token) => {
    return fetch(`${serverUrl}/accounts/allaccounts`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })
}

//upload notes file
export const saveDocument = (data) => {
    const fData = new FormData();
    fData.append("document", data.document);
    return fetch(`${fileServer}/document/upload`, {
        method: "POST",
        mode: 'cors',
        body: fData,
        headers: {
            Accept: "application/json"
        }
    })
}

//upload notes
export const uploadDocument = (token, data) => {
    console.log(data);
    return fetch(`${serverUrl}/accounts/upload_publication`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
        mode: "cors"
    })
}

/** Upload tutorial */
export const uploadTutorial = (token, data) => {
    return fetch(`${serverUrl}/tutorial/create`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
        mode: 'cors'
    })
}

/** upload tutorial questions pdf */
export const uploadExamFile = (token, data) => {
    return fetch(`${serverUrl}/tutorial/exam`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
        mode: 'cors'
    })
}

/** add questions to tutorial */
export const addQuestions = (token, data) => {
    return fetch(`${serverUrl}/tutorial/addquestion`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        }
    })
}

/** update tutorial question by id */
export const updateTutorial = (token, data, id) => {
    return fetch(`${serverUrl}/tutorial/exam/update/${id}`, {
        method: "PATCH",
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        }
    })
}

/** Load by field */
export const getTutorial = (field) => {
    return fetch(`${serverUrl}/tutorial/find/${field}`, {
        method: "GET",
        headers: {
            Accept: "application/json"
        }
    })
}



/** Load exam by field */
export const getExamByField = (field) => {
    return fetch(`${serverUrl}/tutorial/exams/${field}`, {
        method: "GET",
        headers: {
            Accept: "application/json"
        }
    })
}

/** Find exam by id */
export const getExamById = (id) => {
    return fetch(`${serverUrl}/tutorial/exam/${id}`, {
        method: "GET",
        headers: {
            Accept: "application/json"
        }
    })
}

/** update exams */
export const updateExamById = (id, token, data) => {
    return fetch(`${serverUrl}/tutorial/exam/update/${id}`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    })
}


/** Find by id */
export const getTutorialById = (id) => {
    return fetch(`${serverUrl}/tutorial/findbyid/${id}`, {
        method: "GET",
        headers: {
            Accept: "application/json"
        }
    })
}

/** delete any document from server */
export const deleteFile = (url) => {
    return fetch(`${fileServer}/document/delete`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "Application/json"
        },
        body: JSON.stringify({ document: url })
    })
}

/** delete a tutorial by id */
export const deleteTutorialById = (id, token) => {
    return fetch(`${serverUrl}/tutorial/delete/${id}`,{
        method: "DELETE",
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
}

/** delete a past question by id */
export const deleteHNDQuestionById = (id, token) => {
    return fetch(`${serverUrl}/hndpast/delete/${id}`,{
        method: "DELETE",
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
}

/** delete document record from db */
export const deleteDocumentRecord = (id, token) => {
    return fetch(`${serverUrl}/accounts/document/${id}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json"
        }
    })
}

/** update pdf document for notes or project*/
export const updateDocument = (id, token, data) => {
    return fetch(`${serverUrl}/accounts/update_doc/${id}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "Application/json"
        },
        body: JSON.stringify(data),
        mode: "cors"
    })
}

export const subscribeUser = (token, email) => {
    return fetch(`${serverUrl}/tutorial/subscribe`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "Application/json"
        },
        body: JSON.stringify({ email }),
        mode: "cors"
    })
}

export const subscribeToHND = (token, email) => {
    return fetch(`${serverUrl}/tutorial/hndsubscribe`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "Application/json"
        },
        body: JSON.stringify({ email }),
        mode: "cors"
    })
}

export const verifySubscription = (token) => {
    return fetch(`${serverUrl}/tutorial/verifysub`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
            "Accept": "Application/json"
        },
        mode: "cors"
    })
}

/** ################################### HND ################################################### */

/**
 * 
 * @param {object} data 
 * @returns { promise }
 */
export const createPastQuestion = (data, token) => {
    return fetch(`${serverUrl}/hndpast/create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data),
        mode: "cors"
    })
}

/** get past questionby id */
export const getPastQuestionById = (id) => {
    return fetch(`${serverUrl}/hndpast/byId/${id}`, {
        method: "GET",
        mode: "cors"
    })
}

/** get all past questions */
export const getAllPastQuestions = (field) => {
    return fetch(`${serverUrl}/hndpast/all/${field}`, {
        method: "GET",
        mode: "cors"
    })
}

/**get questions for a particular year 
 * @param {string} year
*/
export const getYearQuestions = (year) => {
    return fetch(`${serverUrl}/hndpast/byyear/${year}`, {
        method: "GET",
        mode: "cors"
    })
}

/** update past question data */
export const updatePastQuestion = (id, token, data) => {
    return fetch(`${serverUrl}/hndpast/update/${id}`, {
        method: "PATCH",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    })
}

/** delete a past data */
export const deletePastQuestion = (id, token) => {
    return fetch(`${serverUrl}/hndpast/delete/${id}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}